import { render } from "./SwapBody.vue?vue&type=template&id=2ccb4284&scoped=true"
import script from "./SwapBody.vue?vue&type=script&lang=js"
export * from "./SwapBody.vue?vue&type=script&lang=js"

import "./SwapBody.vue?vue&type=style&index=0&id=2ccb4284&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccb4284"]])

export default __exports__